import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSnowman = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "120px",
	height: "120px",
	viewBox: "0 0 120 120",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Group 21" }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("polygon", {
			id: "path-1",
			points: "0 119.9994 119.9994 119.9994 119.9994 0 0 0"
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Christmas",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Christmas-1",
				transform: "translate(-452.000000, -140.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group-21",
					transform: "translate(452.000000, 140.000000)",
					children: [/* @__PURE__ */ _jsx("polygon", {
						id: "Fill-1",
						fill: "currentcolor",
						points: "102.00009 38.999805 102.00009 56.999715 120 56.999715 120 50.999745 108.00006 50.999745 108.00006 38.999805"
					}), /* @__PURE__ */ _jsxs("g", {
						id: "Group-20",
						children: [
							/* @__PURE__ */ _jsx("path", {
								d: "M44.2665787,54.390778 L42.9420853,52.7512862 C40.3635982,49.1678042 39.000105,44.9303253 39.000105,40.4993475 C39.000105,28.9209054 48.4200579,19.4994525 60,19.4994525 C71.5784421,19.4994525 80.999895,28.9209054 80.999895,40.4993475 C80.999895,44.9303253 79.6364018,49.1678042 77.0564147,52.7512862 L75.9029205,54.2962785 L71.0969445,50.7037965 L72.2174389,49.203804 C74.0264299,46.6898166 74.999925,43.6658317 74.999925,40.4993475 C74.999925,32.2298889 68.2709586,25.4994225 60,25.4994225 C51.7290414,25.4994225 45.000075,32.2298889 45.000075,40.4993475 C45.000075,43.6373318 45.9555702,46.6373168 47.7645612,49.1783041 L48.9240554,50.609297 L44.2665787,54.390778 Z",
								id: "Fill-2",
								fill: "currentcolor"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M59.9997,119.9994 C40.1487993,119.9994 23.99988,103.848981 23.99988,83.99958 C23.99988,74.1206294 27.9208604,64.9061755 35.0428248,58.0542097 L39.202304,62.3786881 C33.2683337,68.0891596 29.99985,75.7676212 29.99985,83.99958 C29.99985,100.541497 43.4577827,113.99943 59.9997,113.99943 C76.5416173,113.99943 89.99955,100.541497 89.99955,83.99958 C89.99955,75.808121 86.7595662,68.1551592 80.8750956,62.4551877 L85.0525747,58.1457093 C92.1115394,64.9886751 95.99952,74.1701291 95.99952,83.99958 C95.99952,103.848981 79.8506007,119.9994 59.9997,119.9994",
								id: "Fill-4",
								fill: "currentcolor"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M54.3234284,19.4999025 L65.6753716,19.4999025 L67.7528612,5.99997 L52.2459388,5.99997 L54.3234284,19.4999025 Z M70.8233459,25.4998725 L49.1754541,25.4998725 L45.2529737,0 L74.7458263,0 L70.8233459,25.4998725 Z",
								id: "Fill-6",
								fill: "currentcolor"
							}),
							/* @__PURE__ */ _jsx("mask", {
								id: "mask-2",
								fill: "white",
								children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#path-1" })
							}),
							/* @__PURE__ */ _jsx("g", { id: "Clip-9" }),
							/* @__PURE__ */ _jsx("polygon", {
								id: "Fill-8",
								fill: "currentcolor",
								mask: "url(#mask-2)",
								points: "40.4997975 25.4998725 79.4996025 25.4998725 79.4996025 19.4999025 40.4997975 19.4999025"
							}),
							/* @__PURE__ */ _jsx("polygon", {
								id: "Fill-10",
								fill: "currentcolor",
								mask: "url(#mask-2)",
								points: "29.3787031 72.6207869 1.75784121 44.999925 5.99982 40.7579462 33.6206819 68.3788081"
							}),
							/* @__PURE__ */ _jsx("polygon", {
								id: "Fill-11",
								fill: "currentcolor",
								mask: "url(#mask-2)",
								points: "17.99991 56.999715 0 56.999715 0 50.999745 11.99994 50.999745 11.99994 38.999805 17.99991 38.999805"
							}),
							/* @__PURE__ */ _jsx("polygon", {
								id: "Fill-12",
								fill: "currentcolor",
								mask: "url(#mask-2)",
								points: "90.6206969 72.6207869 86.3787181 68.3788081 113.99958 40.7579462 118.241559 44.999925"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M40.4997975,61.4996925 L79.4996025,61.4996925 L79.4996025,55.4997225 L40.4997975,55.4997225 L40.4997975,61.4996925 Z M34.4998275,67.4996625 L85.4995725,67.4996625 L85.4995725,49.4997525 L34.4998275,49.4997525 L34.4998275,67.4996625 Z",
								id: "Fill-13",
								fill: "currentcolor",
								mask: "url(#mask-2)"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M76.4996175,77.6451618 L79.4996025,79.1451543 L79.4996025,67.4992125 L73.4996325,67.4992125 L73.4996325,79.1451543 L76.4996175,77.6451618 Z M85.4995725,88.8546057 L76.4996175,84.3546282 L67.4996625,88.8546057 L67.4996625,61.4992425 L85.4995725,61.4992425 L85.4995725,88.8546057 Z",
								id: "Fill-14",
								fill: "currentcolor",
								mask: "url(#mask-2)"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M56.999565,34.4998275 C56.999565,36.1573192 55.6570717,37.4998125 53.99958,37.4998125 C52.3420883,37.4998125 50.999595,36.1573192 50.999595,34.4998275 C50.999595,32.8423358 52.3420883,31.4998425 53.99958,31.4998425 C55.6570717,31.4998425 56.999565,32.8423358 56.999565,34.4998275",
								id: "Fill-15",
								fill: "currentcolor",
								mask: "url(#mask-2)"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M68.999505,34.4998275 C68.999505,36.1573192 67.6570117,37.4998125 65.99952,37.4998125 C64.3420283,37.4998125 62.999535,36.1573192 62.999535,34.4998275 C62.999535,32.8423358 64.3420283,31.4998425 65.99952,31.4998425 C67.6570117,31.4998425 68.999505,32.8423358 68.999505,34.4998275",
								id: "Fill-16",
								fill: "currentcolor",
								mask: "url(#mask-2)"
							}),
							/* @__PURE__ */ _jsx("polygon", {
								id: "Fill-17",
								fill: "currentcolor",
								mask: "url(#mask-2)",
								points: "59.9997 45.9270704 59.9997 38.0731096 67.8536607 42.00009"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M62.999535,77.99961 C62.999535,79.6571017 61.6570417,80.999595 59.99955,80.999595 C58.3420583,80.999595 56.999565,79.6571017 56.999565,77.99961 C56.999565,76.3421183 58.3420583,74.999625 59.99955,74.999625 C61.6570417,74.999625 62.999535,76.3421183 62.999535,77.99961",
								id: "Fill-18",
								fill: "currentcolor",
								mask: "url(#mask-2)"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M62.999535,92.999535 C62.999535,94.6570267 61.6570417,95.99952 59.99955,95.99952 C58.3420583,95.99952 56.999565,94.6570267 56.999565,92.999535 C56.999565,91.3420433 58.3420583,89.99955 59.99955,89.99955 C61.6570417,89.99955 62.999535,91.3420433 62.999535,92.999535",
								id: "Fill-19",
								fill: "currentcolor",
								mask: "url(#mask-2)"
							})
						]
					})]
				})
			})
		})
	]
});
export default SvgSnowman;
